import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem;
    gap: 1rem;
`;

export const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 1rem;
    width: 100%;
`;

export const IconButton = styled.div`
    color: ${Colors.primary[100]};
    cursor: pointer;

    &:hover {
        opacity: "70%";
    }
`;